var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#022137;stroke-width:0.75;}\n"),React.createElement("line",{"id":"Line_68","className":"st0","x1":"5.1","y1":"0.5","x2":"0.1","y2":"0.5","key":1})]);
}

Minus.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 5.3 1","style":{"enableBackground":"new 0 0 5.3 1"},"xmlSpace":"preserve"};

module.exports = Minus;

Minus.default = Minus;
